import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Callout, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
export const GetZapierHeaderTID = (parentTestId)=>getTestIds({
        parentTestId,
        deprecatedTestIds: {
            ZapierHeaderTID: {
                Disclaimer: 'zapier-v2-disclaimer'
            }
        }
    });
export const ZapierHeader = ()=>{
    const { t: zapierTexts } = useLocaleKeys('integrations.availableApps.zapier');
    const { ZapierHeaderTID } = useMemo(()=>GetZapierHeaderTID(), []);
    return /*#__PURE__*/ _jsx(Callout, {
        intent: "info",
        testId: ZapierHeaderTID.Disclaimer(),
        children: zapierTexts.v2Disclaimer()
    });
};
export const ZapierSteps = ()=>{
    const { t: zapierTexts } = useLocaleKeys('integrations.availableApps.zapier');
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                children: zapierTexts.v2Step2()
            }),
            /*#__PURE__*/ _jsx(Typography, {
                children: zapierTexts.v2Step3()
            })
        ]
    });
};
